import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Sidebar from "../../Components/Sidebar";
import { useDispatch, useSelector } from "react-redux";
import { fetchContactUsData, updateContactUsData } from "../../redux/actions/contactusAction";
import PageComponent from "../../Components/PageComponent";

function ContactInformation() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const {
    data: ContactData = [], // Ensure it's always an array
    loading,
    error,
  } = useSelector((state) => state.ContactUs.contactInfo || { data: [] });

  // Local state for form fields
  const [id, setId] = useState(null);
  const [address, setAddress] = useState("");
  const [phone_no, setPhone_no] = useState("");
  const [email_address, setEmail_address] = useState("");
  const [map, setMap] = useState("");
  const [isUpdating, setIsUpdating] = useState(false); // State to track updating process

  // Fetch contact data on mount
  useEffect(() => {
    dispatch(fetchContactUsData());
  }, [dispatch]);

  // Populate local state when ContactData updates
  useEffect(() => {
    if (Array.isArray(ContactData) && ContactData.length > 0) {
      const firstContact = ContactData[0]; // Use the first object in the array
      setId(firstContact.id || null); // Ensure we capture the ID
      setAddress(firstContact.address || "");
      setPhone_no(firstContact.phone_no || "");
      setEmail_address(firstContact.email_address || "");
      setMap(firstContact.map || "");
    }
  }, [ContactData]);

  // Handle update submission
  const handleUpdate = async (e) => {
    e.preventDefault();

    if (!id) {
      alert("ID is missing. Unable to update Contact Us details.");
      return;
    }

    setIsUpdating(true); // Start updating process

    // Dispatch update action
    await dispatch(updateContactUsData({ id, address, phone_no, email_address, map }));

    // Refetch data to ensure consistency after update
    await dispatch(fetchContactUsData());

    setIsUpdating(false); // End updating process
    alert("Contact information updated successfully!");
  };

  // Debug log
  console.log("ContactData:", ContactData);

  // Loading and error handling
  if (loading) {
    return <div className="text-center text-primary-color">Loading...</div>;
  }

  if (error) {
    return <div className="text-center text-red-600">Error: {error}</div>;
  }

  if (!Array.isArray(ContactData)) {
    return <div>Unexpected data format. Please try again later.</div>;
  }

  // Render the form
  return (
    <><PageComponent>
    <div className="flex w-screen h-screen overflow-x-hidden bg-[#F8F7FA]">
      <div className="fixed top-0 left-0 w-64 h-full overflow-y-auto bg-white shadow-md">
        <Sidebar />
      </div>
      <div className="flex-1 p-6 ml-64">
        <div className="flex items-center space-x-2 text-3xl text-gray-500">
          <span>Contact Us</span>
          <span>/</span>
          <span className="text-black">Contact Information</span>
        </div>
        <div className="p-6 mt-6 bg-white rounded-lg shadow-md">
          <h2 className="text-2xl font-bold">Contact Information</h2>
          <form onSubmit={handleUpdate}>
            <div className="grid grid-cols-2 gap-4 mt-6 space-y-4">
              <div>
                <label className="block text-gray-700">Address</label>
                <textarea
                  className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none"
                  placeholder="Enter address"
                  value={address}
                  onChange={(e) => setAddress(e.target.value)}
                  style={{ height: "50px", resize: "none" }}
                  required
                />
              </div>
              <div>
                <label className="block text-gray-700">Phone Number(s)</label>
                <textarea
                  className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none"
                  placeholder="Enter phone number"
                  value={phone_no}
                  onChange={(e) => setPhone_no(e.target.value)}
                  style={{ height: "50px", resize: "none" }}
                  required
                />
              </div>
              <div>
                <label className="block text-gray-700">Email Address</label>
                <textarea
                  className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none"
                  placeholder="Enter email address"
                  value={email_address}
                  onChange={(e) => setEmail_address(e.target.value)}
                  style={{ height: "50px", resize: "none" }}
                  required
                />
              </div>
              <div>
                <label className="block text-gray-700">Google Maps Embed Code</label>
                <textarea
                  className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none"
                  placeholder="Enter Google Maps embed code"
                  value={map}
                  onChange={(e) => setMap(e.target.value)}
                  style={{ height: "50px", resize: "none" }}
                  required
                />
              </div>
            </div>
            <div className="flex justify-end mt-6 space-x-4">
              <button
                type="reset"
                onClick={() => {
                  setAddress("");
                  setPhone_no("");
                  setEmail_address("");
                  setMap("");
                }}
                className="px-4 py-2 text-[#A8AAAE] bg-gray-200 rounded-md hover:bg-gray-300"
              >
                Clear
              </button>
              <button
                type="submit"
                disabled={isUpdating} // Disable button while updating
                className={`px-4 py-2 text-white rounded-md ${
                  isUpdating ? "bg-gray-400 cursor-not-allowed" : "bg-[#92288C] hover:bg-[#6C0B67]"
                }`}
              >
                {isUpdating ? "Updating..." : "Update"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
    </PageComponent></>
  );
}

export default ContactInformation;
